const language = {
    English: {
        search : "Search",
        GPTsearchPlaceHolder: "What would you like to watch today?"
    },
    Hindi: {
        search : "खोज",
        GPTsearchPlaceHolder: "आज आप क्या देखना चाहेंगे?"
    },
    French: {
        search : "recherche",
        GPTsearchPlaceHolder: "Qu’aimeriez-vous regarder aujourd’hui ?"
    },
    
}

export default language;